import { newId } from "../ids.js";
import { isoString, systemClock, type Clock } from "../time.js";
import type { Label, LabelInput } from "./types.js";

/** Build a new Label record from user input. Pure: doesn't persist. */
export function createLabel(input: LabelInput, now: Clock = systemClock): Label {
  const ts = isoString(now());
  return {
    id: newId(),
    name: input.name.trim(),
    color: input.color ?? null,
    created_at: ts,
    updated_at: ts,
    deleted_at: null,
  };
}
